/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_Create_TitleInputs */

const cs_lead_create_title = /** @type {(inputs: Lead_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový lead`)
};

const en_lead_create_title = /** @type {(inputs: Lead_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lead`)
};

/**
* | output |
* | --- |
* | "New lead" |
*
* @param {Lead_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_create_title = /** @type {((inputs?: Lead_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_create_title(inputs)
	return cs_lead_create_title(inputs)
});